import { useTranslation } from "react-i18next";
import "./cw-report.scss";
import { Breadcrumb, Button, Col, Form, Input, Row, Table } from "antd";
import { _adr } from "../../../../address";
import { ExportOutlined, HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";
import { complexDigitToman, convertToGregorian, convertToJalaliWithoutTime, isEmpty, validateInput } from "../../../../tools/tools";
import { Excel } from "antd-table-saveas-excel";
import { NotFound } from "../../../../sources/svg/svg";
import { useDealer } from "../../../../tools/api";
import { useEffect, useState } from "react";
import Loading from "../../../auxiliary/loader/loading";
const CWReport = () => {
  const [t] = useTranslation("global");
  const { queryCoPurchaseDealerByDate } = useDealer();

  const [isLoading, setIsLoading] = useState(false);
  const [isActive, setIsActive] = useState(-1);

  const [frmSearch] = Form.useForm();

  //state current page show Records
  const [currentPage, setCurrentPage] = useState(0);
  // state totalRecord
  const [totalRecord, setTotalRecord] = useState(0);

  const cTable = [
    {
      title: "نام کاربری",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "شماره",
      dataIndex: "msisdn",
      key: "msisdn",
    },

    {
      title: "قیمت (تومان)",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "سودفروش (تومان)",
      dataIndex: "commission",
      key: "commission",
    },
    {
      title: "تاریخ تغییر مالکیت",
      dataIndex: "purchaseDate",
      key: "purchaseDate",
    },
    {
      title: "وضعیت",
      dataIndex: "status",
      key: "status",
    },
  ];
  const [bTable, setBTable] = useState([]);
  const [tTable, setTTable] = useState([]);

  useEffect(() => {
    const callServices = async () => {
      try {
        let valid = await frmSearch.validateFields();
        if (valid) {
          let value = {
            duringdate: frmSearch.getFieldValue("duringdate"),
          };

          handleSearch(value);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (isActive) {
      callServices();
    }
  }, [currentPage]);

  const handleSearch = async (value) => {
    try {
      setIsLoading(true);
      let payload = {
        startDate: convertToGregorian(value?.duringdate[0].format("YYYY-MM-DD"), "-", "-"),
        endDate: convertToGregorian(value?.duringdate[1].format("YYYY-MM-DD"), "-", "-"),
        search: {
          sort: "",
          filter: "",
          entriesperpage: 10,
          page: currentPage === 0 ? 0 : currentPage - 1,
          totalrowcount: 0,
        },
      };
      let response = await queryCoPurchaseDealerByDate(payload);
      if (response) {
        setIsActive(true);
        setBTable(
          response?.Result.map((item, key) => ({
            key: key,
            username: item.username,
            msisdn: item.msisdn,
            price: complexDigitToman(item.purchaseAmount),
            commission: complexDigitToman(item.salesCommission),
            purchaseDate: convertToJalaliWithoutTime(item.operationdate),
            status: (
              <>
                <span>{item.purchasestate}</span>
              </>
            ),
          })),
        );
        setTTable(
          response?.Result?.map((item, key) => ({
            key: key,
            username: item.username,
            msisdn: item.msisdn,
            price: complexDigitToman(item.purchaseAmount),
            commission: complexDigitToman(item.salesCommission),
            purchaseDate: convertToJalaliWithoutTime(item.purchasestate),
            status: (
              <>
                <span>{item.methodfreceipt}</span>
              </>
            ),
          })),
        );
        setTotalRecord(response?.searchconfigmodel?.totalrowcount);
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };
  const handleExport = () => {
    const excel = new Excel();
    let tempTable = bTable.map((item) => {
      return { ...item, status: item.status.props.children.props.children };
    });
    excel
      .addSheet("گزارشات تغییرمالکیت سیم‌کارت")
      .addColumns(cTable)
      .addDataSource(tempTable, { str2Percent: true })
      .saveAs("export-simcard-purchases.xlsx");
  };
  const handleSearchOnTable = (e) => {
    if (!isEmpty(e.target.value)) {
      let temp = tTable.filter((o) => {
        return Object.keys(o).some((k) => {
          return o[k]?.toString()?.toLowerCase()?.includes(e.target.value);
        });
      });
      setBTable(temp);
    } else {
      setBTable(tTable);
    }
  };
  return (
    <>
      <div className="container-main container-cw">
        <div className="g-hold-title-of-page">
          <Breadcrumb
            className="breadcrumbs"
            items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("changeOwnerShip.report.title") }]}
          />

          <div className="title-page">
            <h3>{t("changeOwnerShip.report.title")}</h3>
            <p></p>
          </div>
        </div>
        <div className="g-layout-content">
          <Content className="g-layout-main cw-container">
            <div className="cw-report-list-container">
              <div className="g-layout-report">
                <div className="g-search-area">
                  <Form form={frmSearch} onFinish={handleSearch} layout="vertical">
                    <Row gutter={30}>
                      <Col>
                        <JalaliLocaleListener />
                        <Form.Item
                          name="duringdate"
                          className="input-normal"
                          label="انتخاب تاریخ"
                          rules={[validateInput({ t: t, validate: true, typeOfValue: "array" })]}
                        >
                          <DatePickerJalali.RangePicker format={"YYYY/MM/DD"} />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item label="&nbsp;">
                          <Button htmlType="submit" className="btn-normal btn-green">
                            جستجو
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </div>
                {isActive !== -1 && (
                  <div className="holder-table">
                    <div className="holder-top-table">
                      <div className="holder-search">
                        <Form layout="vertical">
                          <Row gutter={16}>
                            <Col span={6}>
                              <Form.Item className="input-normal" label="جستجو">
                                <Input placeholder="جستجو" allowClear onChange={handleSearchOnTable} suffix={<i className="icon-search"></i>} />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                      <div className="holder-button">
                        <br />
                        <Button onClick={handleExport} icon={<ExportOutlined />} className="btn-normal btn-print">
                          {" "}
                          خروجی اکسل{" "}
                        </Button>
                      </div>
                    </div>
                    <Table
                      className="tbl-normal"
                      columns={cTable}
                      locale={{
                        emptyText: (
                          <>
                            <NotFound text={"رکوردی یافت نشد."} />
                          </>
                        ),
                      }}
                      pagination={{
                        className: "page-pagination",
                        // position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
                        onChange: (page) => {
                          setCurrentPage(page);
                        },
                        pageSize: 10,
                        align: "start",
                        current: currentPage === 0 ? 1 : currentPage,
                        total: totalRecord,
                        showSizeChanger: false,
                      }}
                      dataSource={bTable}
                    ></Table>
                  </div>
                )}
              </div>
            </div>
          </Content>
          <Loading isOpen={isLoading} />
        </div>
      </div>
    </>
  );
};

export default CWReport;
